<div *ngIf="!paymentSuccess" class="page-container">
  <div class="header">
    <h1>Upgrade auf Sparkly Premium</h1>
    <span>Alles was du brauchst, um maximal effizient zu lernen</span>
  </div>
  
  <div>
    <div class="list">
      <div *ngFor="let benefit of benefits" class="list-item">
        <i-tabler [name]="benefit.icon"></i-tabler>
        <div>
          <span class="title">{{benefit.title}}</span>
          <span class="description">{{benefit.description}}</span>
        </div>
      </div>
    </div>
    <app-button *ngIf="!showAllBenefits" class="show-all-benefits" [text]="'Alle Vorteile anzeigen'" [style]="'outlined'" [size]="'small'" (clickEvent)="showAdditionalBenefits()"></app-button>
  </div>

  <div class="prices-container">
    <div class="widgets-container">
      <div class="type-widget monthly" [class.selected]="paymentInterval === 'monthly'" (click)="paymentInterval  = 'monthly'">
        <span class="title">1 Monat</span>
        <div class="price-container-1">
          <span class="price">4,99</span>
          <span class="price-description">€ / Monat</span>
        </div>
        <i class="fas fa-check-circle"></i>
      </div>
      
      <div class="type-widget" [class.selected]="paymentInterval === 'yearly'" (click)="paymentInterval  = 'yearly'">
        <span class="title">12 Monate</span>
        <div class="price-container">
          <div class="price-container-1">
            <span class="price">1,99</span>
            <span class="price-description">€ / Monat</span>
          </div>
          <span class="monthly-price">23,88 € / Jahr</span>
        </div>
        <i class="fas fa-check-circle"></i>
      </div>
    </div>
    <span class="mwst-info">19% MwSt. in den Preisen inbegriffen</span>
  </div>

  <!--<app-stripe-payment></app-stripe-payment>-->

  <div class="button-container">
    <span *ngIf="paymentFailed" class="error-message">Der Bezahlvorgang konnte nicht vollständig abgeschlossen werden. Bitte versuche es erneut.</span>
    <span class="legal-notice">Mit dem Klick auf 'Weiter zur Zahlung' stimmst du unseren <a href="terms">AGB</a> und <a href="privacy-policy">Datenschutzrichtlinien</a> zu.</span>
    <app-button [text]="'Weiter zur Zahlung'" [size]="'large'" (clickEvent)="handlePayment()"></app-button>
    <div class="safe-payment">
      <i-tabler name="lock"></i-tabler>
      <span class="text">Sichere Zahlung mit</span>
      <img class="stripe-logo" src="assets/images/stripe-wordmark-purple.svg">
    </div>
  </div>
</div>

<div *ngIf="paymentSuccess" class="page-container">
  <app-success-screen [title]="'Bezahlung erfolgreich.'" [message]="'Die Premium-Funktionen wurden freigeschaltet. Jetzt kann es richtig losgehen. Dein Abo kannst du jederzeit in deinem Profil verwalten.'" [buttonText]="'Zum Dashboard'" (buttonClicked)="navigateToDashboard()"></app-success-screen>
</div>


